// HTTP 拦截器配置
import { httpClient } from './http';
import { APIError } from '@/types/api';
import { message } from 'antd';

// 请求拦截器 - 添加认证头
const authInterceptor = (config: RequestInit): RequestInit => {
  const token = localStorage.getItem('token');
  return {
    ...config,
    headers: {
      ...config.headers,
      ...(token && { Authorization: `Bearer ${token}` }),
    },
  };
};

// 响应拦截器 - 处理通用响应
const responseInterceptor = (response: Response): Response => {
  // 可以在这里添加通用的响应处理逻辑
  // 比如记录日志、更新token等
  return response;
};

// 错误拦截器 - 统一错误处理
const errorInterceptor = async (error: APIError | Error): Promise<APIError> => {
  // 处理非 APIError 类型的错误（如 JSON 解析错误）
  let apiError: APIError;
  if ('code' in error && typeof error.code === 'number') {
    apiError = error as APIError;
  } else {
    // 转换普通 Error 为 APIError
    apiError = {
      code: 500,
      message: error.message || '未知错误',
      details: error,
    };
  }

  // 对于 401 未授权错误，统一处理：清除认证信息并跳转到登录页
  if (apiError.code === 401) {
    // 清除本地存储的认证信息
    localStorage.removeItem('token');
    localStorage.removeItem('userInfo');
    localStorage.removeItem('isLoggedIn');
    
    // 如果当前不在登录页，则跳转到登录页
    if (window.location.pathname !== '/login') {
      message.error('登录已过期，请重新登录');
      // 使用 window.location.href 确保完全跳转
      window.location.href = '/login';
      return apiError;
    } else {
      // 在登录页时，不显示过期提示，只显示具体错误
      if (apiError.message && !apiError.message.includes('HTTP error')) {
        message.error(apiError.message);
      }
    }
    return apiError;
  }

  // 处理其他错误码
  if (apiError.code !== 200) {
    // 根据错误码显示不同的提示信息
    switch (apiError.code) {
    case 400:
      message.error(apiError.message || '请求参数错误，请检查输入');
      break;
    case 403:
      message.error('没有权限访问该资源');
      break;
    case 404:
      message.error('请求的资源不存在');
      break;
    case 408:
      message.error('请求超时，请检查网络连接');
      break;
    case 422:
      message.error('请求参数格式错误');
      break;
    case 500:
      message.error('服务器内部错误，请稍后重试');
      break;
    case 502:
    case 503:
    case 504:
      message.error('服务暂时不可用，请稍后重试');
      break;
    default:
      // 对于所有其他错误码，显示具体的错误信息
      if (apiError.message && !apiError.message.includes('HTTP error')) {
        message.error(`请求失败：${apiError.message}`);
      } else {
        message.error(`请求失败，错误码：${apiError.code}`);
      }
      break;
    }
  }

  return apiError;
};

// 注册拦截器
export const setupInterceptors = () => {
  httpClient.addRequestInterceptor(authInterceptor);
  httpClient.addResponseInterceptor(responseInterceptor);
  httpClient.addErrorInterceptor(errorInterceptor);
};

// 导出拦截器函数，供外部使用
export { authInterceptor, responseInterceptor, errorInterceptor };
